import './index.less'
import jkyNav from '../../common/components/jky-nav'
import { QualitySwiper } from "../quality-center/sections/quality-swiper";
import { Education } from "./sections/education";
import {RegularBanner} from '../five-kwh-market/sections/five-kwh-banner/index'

document.addEventListener('DOMContentLoaded', () => {
    new RegularBanner(document.querySelector('.five-kwh-banner .swiper-container'))
    new QualitySwiper()
    jkyNav()
    new Education(".education");
 })